/**
 *
 * Styles for OfferProperties
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";

export const PropertiesWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;

  @media print {
    margin-top: 0;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${(props) =>
      props.variationType === "WCCMultiBUOfferCard"
        ? "0 var(--dui-size-space-10x) 0;"
        : "0;"};
  }
`;

export const PropertiesContent = styled.div`
  dhl-list > .dhl-list.bullet:is(ul, ol) {
    list-style-type: square;
    margin-bottom: 2.1rem;
    margin-top: 14px;
    padding-inline-start: 16px;
    gap: 2.1rem;

    dhl-list > .dhl-list.bullet:is(ul, ol) > dhl-list-item > li::before {
      width: 20px;
    }

    dhl-list-item > li::marker {
      color: var(--dui-color-red-500);
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: 0;
    margin-right: calc(var(--dui-size-space-5x) + var(--dui-size-space-1));
  }

  @media print {
    & ul li {
      margin-bottom: 0rem;
    }
  }
`;

export const PropertiesHeadline = styled(Headline)`
  margin-bottom: var(--gaq-size-space-5px);
  font-stretch: normal !important;
`;

export const PropertiesText = styled(DhlText)`
  display: block;
  & > *:is(p, span) {
    margin: 0;
    line-height: var(--dui-size-line-height-5xl);
  }
`;
